import React from "react"

function ContentD() {
  return (
    <svg viewBox="0 0 266 150" fill="none">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={20}
        y={59}
        width={70}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect x={20} y={70} width={92} height={4} rx={2} fill="var(--base-500)" />
      <rect x={20} y={78} width={79} height={4} rx={2} fill="var(--base-500)" />
      <rect x={20} y={88} width={24} height={4} rx={2} fill="var(--main-500)" />
      <rect
        x={144}
        y={65}
        width={40}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <rect
        x={144}
        y={74}
        width={22}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={144}
        y={79}
        width={28}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={144}
        y={84}
        width={19}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={180}
        y={74}
        width={18}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={180}
        y={79}
        width={24}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={180}
        y={84}
        width={24}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={212}
        y={74}
        width={18}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={212}
        y={79}
        width={24}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={212}
        y={84}
        width={24}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <path
        d="M128 44.5a.5.5 0 011 0v62a.5.5 0 01-1 0v-62z"
        fill="var(--base-400)"
      />
    </svg>
  )
}

export default ContentD;
